// ===== oddit-section-collection-main-grid =====
/* ==========================================================================
   Collection Grid — oddit-section-collection-main-grid
   Filter drawer + filter group toggle interactions
   ========================================================================== */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-main-grid';
  var DRAWER_SELECTOR = '.oddit-section-collection-main-grid__filter-drawer';
  var OPEN_BTN_SELECTOR = '.oddit-section-collection-main-grid__pill--filter-mobile';
  var CLOSE_BTN_SELECTOR = '.oddit-section-collection-main-grid__filter-drawer-close';
  var OVERLAY_SELECTOR = '.oddit-section-collection-main-grid__filter-drawer-overlay';
  var HEADING_ROW_SELECTOR = '.oddit-section-collection-main-grid__filter-heading-row';

  function initSection(section) {
    var drawer = section.querySelector(DRAWER_SELECTOR);
    var openBtn = section.querySelector(OPEN_BTN_SELECTOR);
    var closeBtn = drawer ? drawer.querySelector(CLOSE_BTN_SELECTOR) : null;
    var overlay = drawer ? drawer.querySelector(OVERLAY_SELECTOR) : null;

    // --- Drawer filters: defer submit until the View All button is clicked ---
    if (drawer) {
      var drawerInputs = drawer.querySelectorAll('input[type="checkbox"], input[type="number"]');
      for (var d = 0; d < drawerInputs.length; d++) {
        drawerInputs[d].removeAttribute('onchange');
      }
    }

    // --- Filter Drawer ---
    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + scrollY + 'px';
      document.body.classList.add('oddit-scroll-locked');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      var scrollY = parseInt(document.body.style.top || '0', 10) * -1;
      document.body.classList.remove('oddit-scroll-locked');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      if (openBtn) openBtn.focus();
    }

    if (openBtn) {
      openBtn.addEventListener('click', openDrawer);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Close drawer on Escape
    if (drawer) {
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDrawer();
        }
      });
    }

    // --- Filter Group Toggles ---
    var headingRows = section.querySelectorAll(HEADING_ROW_SELECTOR);
    for (var i = 0; i < headingRows.length; i++) {
      (function (row) {
        row.addEventListener('click', function () {
          var expanded = row.getAttribute('aria-expanded') === 'true';
          row.setAttribute('aria-expanded', String(!expanded));
          var optionsList = row.nextElementSibling;
          if (optionsList) {
            optionsList.style.display = expanded ? 'none' : '';
          }
        });
      })(headingRows[i]);
    }

    // --- Reveal animation (static preview) ---
    var reveals = section.querySelectorAll('.oddit-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('is-visible');
            observer.unobserve(entries[j].target);
          }
        }
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

      for (var k = 0; k < reveals.length; k++) {
        observer.observe(reveals[k]);
      }
    } else {
      // Fallback: show everything
      for (var m = 0; m < reveals.length; m++) {
        reveals[m].classList.add('is-visible');
      }
    }
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();

// ===== oddit-collection-filter-drawer =====
/* ==========================================================================
   oddit-collection-filter-drawer
   Mobile filter drawer — open/close, collapsible groups, focus trap
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-collection-filter-drawer';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function initSection(section) {
    var panel = section.querySelector('.oddit-collection-filter-drawer__panel');
    var closeBtn = section.querySelector('.oddit-collection-filter-drawer__close');
    var overlay = section.querySelector('.oddit-collection-filter-drawer__overlay');
    var groupHeaders = section.querySelectorAll('.oddit-collection-filter-drawer__group-header');
    var triggerElement = null;

    /* ---- Open / Close ---- */

    function open(trigger) {
      triggerElement = trigger || document.activeElement;
      section.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      panel.addEventListener('transitionend', function onEnd() {
        panel.removeEventListener('transitionend', onEnd);
        var first = panel.querySelector(FOCUSABLE);
        if (first) first.focus();
      }, { once: true });
    }

    function close() {
      section.classList.remove('is-open');
      document.body.style.overflow = '';

      if (triggerElement && typeof triggerElement.focus === 'function') {
        triggerElement.focus();
      }
      triggerElement = null;
    }

    /* ---- Event listeners ---- */

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (overlay) {
      overlay.addEventListener('click', close);
    }

    section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && section.classList.contains('is-open')) {
        close();
      }

      // Focus trap
      if (e.key === 'Tab' && section.classList.contains('is-open')) {
        var focusable = panel.querySelectorAll(FOCUSABLE);
        if (focusable.length === 0) return;

        var firstEl = focusable[0];
        var lastEl = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      }
    });

    /* ---- Collapsible groups ---- */

    for (var i = 0; i < groupHeaders.length; i++) {
      (function (header) {
        header.addEventListener('click', function () {
          var expanded = header.getAttribute('aria-expanded') === 'true';
          var targetId = header.getAttribute('aria-controls');
          var target = targetId ? document.getElementById(targetId) : null;

          header.setAttribute('aria-expanded', String(!expanded));

          if (target) {
            if (expanded) {
              target.setAttribute('hidden', '');
            } else {
              target.removeAttribute('hidden');
            }
          }
        });
      })(groupHeaders[i]);
    }

    /* ---- Public API (for external triggers) ---- */

    section._odditFilterDrawer = { open: open, close: close };
  }

  /* ---- Init ---- */

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  /* ---- External trigger: any element with [data-open-filter-drawer] ---- */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-open-filter-drawer]');
    if (!trigger) return;

    var drawer = document.querySelector(SECTION_SELECTOR);
    if (drawer && drawer._odditFilterDrawer) {
      drawer._odditFilterDrawer.open(trigger);
    }
  });

  /* ---- Collection card material swatches (TT1-18) ----
     Clicking a swatch updates the card image + card link to that material
     variant in place, instead of navigating to the product page. The <a>
     keeps its href so it still works without JS. */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-card-swatch]');
    if (!swatch) return;

    var card = swatch.closest('.oddit-section-collection-main-grid__card');
    if (!card) return;

    e.preventDefault();

    var imageUrl = swatch.getAttribute('data-variant-image');
    var variantUrl = swatch.getAttribute('data-variant-url');

    var img = card.querySelector('.oddit-section-collection-main-grid__card-img');
    if (img && imageUrl) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imageUrl;
    }

    var link = card.querySelector('.oddit-section-collection-main-grid__card-link');
    if (link && variantUrl) link.setAttribute('href', variantUrl);

    var swatches = card.querySelectorAll('[data-card-swatch]');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('oddit-section-collection-main-grid__swatch--active');
    }
    swatch.classList.add('oddit-section-collection-main-grid__swatch--active');
  });

  /* ---- Shopify theme editor support ---- */

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
